/* global mixpanel */
import React from 'react'
import { connect } from 'react-redux'
import * as actionCreators from '../redux/action_creators'
import CalendarSidebar from '../components/layout/calendar_sidebar'
import TimeEntryList from '../components/layout/time_entry_list'
import DashNav from '../components/layout/dash_nav'
import { getUserTimeEntries, getItemsArray } from '../util/prop_utils'
import * as dateUtils from '../util/date_utils'
import * as timeUtils from '../util/time_utils'
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar'
import OptionDropdown from '../components/option_dropdown'
import PersonalDashButtonGroup from '../components/personal_dash_button_group'
import Dashboard from './dashboard'
import GA from "react-ga"

class PersonalDashboard extends Dashboard {
    constructor(props) {
        super(props)

        this.renderButtonBar = this.renderButtonBar.bind(this)
        this.loadTeamIfNeeded = this.loadTeamIfNeeded.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const { viewport, profile, fetchTimeEntries } = this.props
        // TODO: Refactor the `bootstrap` action for v2 including fetchTimeEntries
        //       and remove this code
        if (!profile.id && nextProps.profile.id) {
            // only fetch time entries once profile has been hydrated (so we can filter by ownerId)
            fetchTimeEntries(viewport.horizon)
        }
        if (!viewport.teamId || viewport.teamId != nextProps.viewport.teamId) {
            this.loadTeamIfNeeded(nextProps)
        }
    }

    loadTeamIfNeeded(props) {
        const { viewport, profile } = props
        if (profile.personalTeamId !== viewport.teamId) {
            const teamId = profile.personalTeamId
            mixpanel.track("View personal dashboard", {teamId})
            GA.event({category: "User", action: "View personal dashboard"})

            this.props.selectTeamDashboard(teamId)
            this.props.fetchCurrentHorizon()
        }
    }

    onCollapseChange = (collapse) => {
        this.props.setDashboardCollapse(collapse)
    }

    onGroupByChange = (chosenGroupBy) => {
        this.props.setDashboardGroupBy(chosenGroupBy)
    }

    calcContainerWidth() {
        const hPadding = 28 // TODO: determine dynamically
        const container = document.querySelector('.display-container')
        return container ? (container.clientWidth - hPadding) : 0
    }

    renderButtonBar() {
        const display = this.props.viewport ? this.props.viewport.display : 'list'
        const { collapse } = this.props.viewport

        return (
            <ButtonToolbar>
                <PersonalDashButtonGroup
                    display={display}
                    onDisplayChange={this.onDisplayChange}
                />
                <OptionDropdown
                    collapse={collapse}
                    groupBy={this.props.viewport.groupBy}
                    onCollapseChange={this.props.setDashboardCollapse}
                    onGroupByChange={this.onGroupByChange}
                />
            </ButtonToolbar>
        )
    }

    render() {
        const { tags, profile, teams, isMobile } = this.props
        const { id: profileId, personalTeamId } = profile
        const timeEntriesArray = getUserTimeEntries(this.props.timeEntries, profileId)
        const allRunningEntries = this.props.runningTimeEntries || {}
        const runningEntries = profileId ? (allRunningEntries[profileId] || []) : []
        const rollups = this.getRollups(timeEntriesArray, runningEntries)
        const timeEntries = this.props.timeEntries.items
        const editTimeEntry = this.props.editTimeEntry
        // conversion from v2 shape to v1 shape (also see v2/app.jsx)
        const teamsList = getItemsArray(teams)
        const teamsMap = teams.items
        const display = this.props.viewport ? this.props.viewport.display : 'list'

        const { interval, increment, ...span } = this.props.viewport.range
        const { collapse } = this.props.viewport
        const incrementToUse = collapse ? increment : 'Day'
        const title = dateUtils.dateRangeString(interval, span, {short: true, hideYear: interval !== 'Month'})
        const totalHrs = timeUtils.msToHrsRounded(rollups.reduce( (acc, r) => acc + r.total, 0))

        const containerWidth = this.calcContainerWidth()
        const personalTeam = teamsMap[personalTeamId]
        const tagReportUser = this.profileToUser(profile)

        const { trialEnd } = this.props.customer

        return (
            <div>
                <div className="dashboard">
                    <div className="display-container">
                        <DashNav
                            handleRangeSelect={this.handleSelect}
                            title={title}
                            onClickBackward={this.moveBackward}
                            onClickForward={this.moveForward}
                            defaultSelectedOption={'Week'}
                            totalHrs={totalHrs}
                            renderButtonBar={this.renderButtonBar}
                        />

                        {display === 'calendar' &&
                        <CalendarSidebar
                            day={span.start}
                            tags={tags}
                            timeEntriesArray={timeEntriesArray}
                            editTimeEntry={editTimeEntry}
                            width={containerWidth}
                            onDayChange={this.onDayChange}
                        />}

                        {display === 'list' &&
                        <TimeEntryList
                            userId={profile.id}
                            timeEntries={timeEntries}
                            timeEntryRollups={rollups}
                            tags={this.props.tags.items}
                            increment={incrementToUse}
                            createTimeEntry={this.props.createTimeEntry}
                            updateTimeEntry={this.props.updateTimeEntry}
                            teams={teamsList}
                            editTimeEntry={editTimeEntry}
                            isCollapsed={collapse}
                            openTimeEntryModal={this.props.openTimeEntryModal}
                            isMobile={isMobile}
                            trialEnd={trialEnd}
                        />}
                    </div>

                    {this.renderTagSideBar(personalTeam, timeEntriesArray)}

                    {this.renderModals(null, tagReportUser)}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(
    mapStateToProps, actionCreators
)(PersonalDashboard)



// WEBPACK FOOTER //
// ./src/pages/personal_dashboard.jsx